import CryptoJS from "crypto-js";
import config from "./config";

// Gets the CMS base URL based on current environment
// const getCMSBaseURL = () => {
//   const hostname = window.location.hostname;
//   console.log(hostname,'hostname');
//   if (hostname.includes('uat')) {
//     return 'https://uat.abg-miceportal.com';
//   } else if (hostname.includes('dev') || hostname === 'localhost') {
//     return 'https://dev.abg-miceportal.com';
//   } else {
//     // Production environment
//     return 'https://www.abg-miceportal.com';
//   }
// };

/**
 * Generates CMS redirect URL with authentication tokens
 * @returns {string} Complete CMS redirect URL with authentication parameters
 */
export const generateCMSRedirectURL = () => {
  try {
    // Get authentication tokens from session storage
    const accessToken = getDecryptedToken("access_token");
    const refreshToken = getDecryptedToken("refresh_token");
    const sessionId = getDecryptedToken("session_id");

    if (!accessToken || !refreshToken || !sessionId) {
      console.error("Missing authentication tokens for CMS redirect");
      return null;
    }

    // Create the token object
    const tokenObject = {
      access_token: accessToken,
      refresh_token: refreshToken,
      session_id: sessionId
    };

    // Encode the token object as URL parameter
    const encodedToken = encodeURIComponent(JSON.stringify(tokenObject));

    // Construct the CMS redirect URL
    // const cmsRedirectURL = `https://abg-connect-dev.web.app/redirect?TN=${encodedToken}`; // Dev
    const cmsRedirectURL = `https://devcms.abg-miceportal.com/redirect?TN=${encodedToken}`; // Prod

    return cmsRedirectURL;
  } catch (error) {
    console.error("Error generating CMS redirect URL:", error);
    return null;
  }
};

/**
 * Helper function to decrypt tokens from session storage
 * @param {string} tokenKey - The key for the token in session storage
 * @returns {string|null} Decrypted token or null if error
 */
const getDecryptedToken = (tokenKey) => {
  try {
    const encryptedToken = sessionStorage.getItem(tokenKey);
    if (!encryptedToken) return null;

    const bytes = CryptoJS.AES.decrypt(encryptedToken, config.tokenKey);
    const jsonString = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(jsonString);
  } catch (error) {
    console.error(`Error decrypting ${tokenKey}:`, error);
    return null;
  }
};

// export const getCMSLoginURL = () => {
//   const cmsBaseURL = getCMSBaseURL();
//   return `${cmsBaseURL}/cms`;
// };

/**
 * Redirects to CMS portal with authentication
 */
export const redirectToCMS = () => {
  const cmsURL = generateCMSRedirectURL();
  if (cmsURL) {
    // Has valid tokens, redirect with authentication
    window.open(cmsURL, '_blank');
  } else {
    console.error("Unable to generate CMS redirect URL");
    // No valid tokens, redirect to CMS login page
    // console.log("No valid tokens found, redirecting to CMS login page");
    // const loginURL = getCMSLoginURL();
    // window.open(loginURL, '_blank');
  }
};
